export default {
  kind: 'text',
  mask: 'normal',
  title: '',
  required: false,
  help: '',
  value: '',
}
